// src/modules/feed/components/ActivitiesFeed/hooks/useAttachments.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useAttachments = (activities) => {
    const [attachments, setAttachments] = useState({});

    useEffect(() => {
        const fetchAttachments = async () => {
            const newAttachments = {};
            for (const activity of activities) {
                if (activity.attachments?.length > 0) {
                    for (const attachment of activity.attachments) {
                        try {
                            const response = await axios.get(attachment.url, { responseType: 'blob' });
                            newAttachments[attachment.url] = URL.createObjectURL(response.data);
                        } catch (error) {
                            console.error('Error fetching attachment:', error);
                        }
                    }
                }
            }
            setAttachments(newAttachments);
        };

        fetchAttachments();
    }, [activities]);

    return { attachments };
};
